import script from "./terminal-list-top10.vue?vue&type=script&setup=true&lang=ts"
export * from "./terminal-list-top10.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__